import FadeIn from "./FadeIn";
import { useLang } from "../../contexts/LanguageContext";

export default function Services({ content }) {
  const { t } = useLang();
  const items = content?.services?.items || [];

  return (
    <section
      id="services"
      className="bg-[#f3f3f0] py-24 md:py-32"
      data-testid="services-section"
    >
      <div className="container-x">
        <FadeIn>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16 md:mb-20">
            <div className="md:col-span-4">
              <div className="eyebrow">{t(content?.services?.eyebrow)}</div>
            </div>
            <h2
              className="md:col-span-8 font-display font-bold text-[#16181c] text-4xl sm:text-5xl md:text-6xl leading-[1.02]"
              data-testid="services-heading"
            >
              {t(content?.services?.heading)}
            </h2>
          </div>
        </FadeIn>

        <div className="border-t border-[#e3e3e1]" data-testid="services-list">
          {items.map((item, idx) => (
            <FadeIn key={idx}>
              <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-10 md:py-14 border-b border-[#e3e3e1]">
                <div className="md:col-span-1">
                  <div className="font-display text-[#5d5f64] text-2xl md:text-3xl font-medium">
                    {String(idx + 1).padStart(2, "0")}
                  </div>
                </div>
                <div className="md:col-span-5">
                  <h3 className="font-display font-semibold text-[#16181c] text-2xl md:text-3xl leading-tight tracking-[-0.01em]">
                    {t(item.title)}
                  </h3>
                  {item.sbu && (
                    <div className="eyebrow mt-3" data-testid={`service-sbu-${idx}`}>
                      SBU · {item.sbu}
                    </div>
                  )}
                </div>
                <div className="md:col-span-6">
                  <p className="text-[#16181c] text-base md:text-[17px] leading-relaxed">
                    {t(item.description)}
                  </p>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
